import { QueryBuilderAstNodeType, QueryBuilderTokenType } from '../../../types';
import { parseQueryExpression } from './helpers';

export const buildQueryAst = (
  tokens: QueryBuilderTokenType[]
): QueryBuilderAstNodeType | null => {
  if (tokens.length === 0) {
    return null;
  }

  if (tokens.some((token) => token.type === 'entity')) {
    return null;
  }

  const parsedExpression = parseQueryExpression(tokens, 0);

  if (!parsedExpression || parsedExpression.nextIndex !== tokens.length) {
    return null;
  }

  return parsedExpression.node;
};
